import { createSlice } from '@reduxjs/toolkit';
import { orderResponse, successfulOrderResponse } from '@repo/ecommerce-api';

const initialState: successfulOrderResponse = {
  order: {
    id: 0,
    requestId: 0,
    merchantOrderId: '',
    merchantName: '',
    price: 0,
    products: '',
    document: '',
    redirectURL: '',
    description: '',
    currency: '',
    status: 'Pending',
    creationDate: '',
    successfulDate: '',
    ecommerce: '',
    integrationType: '',
    idComercio: 0,
    idNivel: 0,
    commercialPlanCode: '',
    installments: 0,
    installmentAmount: 0,
    commercialPolicyCode: '',
    commercialPolicyDescription: '',
    policyProduct: '',
    orderSeller: {
      orderId: 0,
      fullName: '',
      documentNumber: '',
      email: '',
      phoneNumber: '',
      gender: '',
      creationDate: '',
    },
    qrCodeBase64: '',
    funnel: [],
    requestedReverse: false,
  },
  credit: {
    id: 0,
    nombreComercio: '',
    nombre: '',
    idComercio: 0,
    idSucursal: 0,
    numeroCredito: '',
    numeroLiquidacion: '',
    estadoSolicitud: '',
    fechaDeDesembolso: '',
    desembolsada: false,
  },
};

export const currentOrderSlice = createSlice({
  name: 'currentOrder',
  initialState,
  reducers: {
    setCurrentSuccesfulOrder: (state, action: { payload: successfulOrderResponse }) => ({
      ...state,
      ...action.payload,
    }),
    setCurrentPendingOrder: (state, action: { payload: orderResponse }) => ({
      ...state,
      order: action.payload,
    }),
    clearCurrentOrder: () => {
      return initialState;
    },
  },
});

export const { setCurrentSuccesfulOrder, setCurrentPendingOrder, clearCurrentOrder } = currentOrderSlice.actions;

export default currentOrderSlice.reducer;
